import { Card, Text } from '@components/ui';
import type { JobDetails } from '@features/buyer/jobs/single-job-detail';
import { useJobDetailQuery } from '@lib/api/jobs';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { RatingDetailAside } from './rating-detail-aside';
import { RatingDetailHeader } from './rating-detail-header';
import { R8trNotes, WalkAroundVideos } from './rating-media';
import { RatingResults } from './rating-results';
import type { RatingDetailJob } from './ratingDetailTypes';

const ASIDE_WIDTH = 340;

const pageSx = {
  width: '100%',
  maxWidth: 1120,
  mx: 'auto',
  boxSizing: 'border-box',
  px: { xs: 2, md: 4 },
  py: 3,
};

const RatingDetail = (): JSX.Element => {
  const { t } = useTranslation();
  const location = useLocation();
  const listJob = (location.state as { jobData?: RatingDetailJob } | null)
    ?.jobData;
  const jobId = listJob?.id == null ? undefined : String(listJob.id);
  const { data } = useJobDetailQuery(jobId);

  if (!jobId || !listJob) {
    return (
      <Box sx={pageSx}>
        <Card>
          <Text tone="muted">{t('ratingDetail.noJob')}</Text>
        </Card>
      </Box>
    );
  }

  const job: JobDetails = { ...listJob, ...(data as JobDetails | undefined) };

  return (
    <Box sx={pageSx}>
      <RatingDetailHeader jobId={jobId} job={job} />
      <Box
        sx={{
          mt: 2,
          display: 'grid',
          gridTemplateColumns: {
            xs: 'minmax(0, 1fr)',
            lg: `minmax(0, 1fr) ${ASIDE_WIDTH}px`,
          },
          alignItems: 'start',
          gap: 2,
        }}
      >
        <Box sx={{ display: 'grid', gap: 2, minWidth: 0 }}>
          <RatingResults jobId={jobId} />
          {job.includeWalkAroundVideos ? (
            <WalkAroundVideos jobId={jobId} />
          ) : null}
          <R8trNotes jobId={jobId} />
        </Box>
        <RatingDetailAside job={job} />
      </Box>
    </Box>
  );
};

export default RatingDetail;
